// extracted by mini-css-extract-plugin
module.exports = {"box":"box-3CtuYPRB clearfix"};